import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forAudience = ['Hombres latinos de 40 a 60 años que viven y trabajan en USA.', 'Vendedores, contratistas y dueños de negocio bajo mucha presión.', 'Padres que quieren tener energía para sus hijos al llegar a casa.', 'Hombres que han notado una pérdida de fuerza y un aumento de grasa abdominal.'];
const notForAudience = ['Jóvenes de 20 años que buscan solo verse bien para la playa.', "Personas que buscan una 'pastilla mágica' sin hacer cambios mínimos.", 'Fisicoculturistas que quieren rutinas de pesas de 2 horas.'];
export function AudienceSection() {
  return <section className="py-16 md:py-24 px-6 bg-brand-card" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-3">
          {/* PARA QUIÉN ES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-surface rounded-2xl p-8 border-t-4 border-brand-green shadow-lg" data-id="element-4">
            <h3 className="font-heading font-bold text-2xl md:text-3xl text-brand-text uppercase mb-8 flex items-center gap-3" data-id="element-5">
              <CheckCircle2 className="w-8 h-8 text-brand-green" aria-hidden="true" data-id="element-6" />
              Para Quién ES
            </h3>
            <ul className="space-y-5" role="list" data-id="element-7">
              {forAudience.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-8">
                  <div className="w-2 h-2 rounded-full bg-brand-green mt-2.5 flex-shrink-0" aria-hidden="true" data-id="element-9" />
                  <span className="font-body text-brand-text leading-relaxed" data-id="element-10">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* PARA QUIÉN NO ES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-surface rounded-2xl p-8 border-t-4 border-brand-red shadow-lg opacity-90" data-id="element-11">
            <h3 className="font-heading font-bold text-2xl md:text-3xl text-brand-muted uppercase mb-8 flex items-center gap-3" data-id="element-12">
              <XCircle className="w-8 h-8 text-brand-red" aria-hidden="true" data-id="element-13" />
              Para Quién NO ES
            </h3>
            <ul className="space-y-5" role="list" data-id="element-14">
              {notForAudience.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-15">
                  <div className="w-2 h-2 rounded-full bg-brand-red mt-2.5 flex-shrink-0" aria-hidden="true" data-id="element-16" />
                  <span className="font-body text-brand-muted leading-relaxed" data-id="element-17">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}